

import $ from 'jquery';
require("imports-loader?jQuery=jquery!../lib/jquery.autocomplete.js");

var prevSearch;
export default function initLocationSelector() {
    if ($("input.PrefServiceChooser").length) {
        var timeoutid;

        BindControlEvents();

        var prm = Sys.WebForms.PageRequestManager.getInstance();
        prm.add_initializeRequest(InitializeRequest);
        prm.add_endRequest(EndRequest);
        prm.add_initializeRequest(InitializeFormRequest);
        prm.add_endRequest(EndFormRequest);
        ToogleGuardianTable();
        // Place here the first init of the autocomplete
        InitAutoCompl();
    }
}

function InitializeRequest(sender, args) {
}

function EndRequest(sender, args) {

    // after update occur on UpdatePanel re-init the Autocomplete
    InitAutoCompl();
}



function ToogleGuardianTable() {
    var ageBracket = $("select[name*='AgeBracket']");
    if (ageBracket.val() == "Under18") {
        $("#guardian-table").show();
    }
    else {
        $("#guardian-table").hide();
    }
}

function CopyAddressFields() {
    $("[id$='chkAddressCopier']").change(function (event) {
        if ($(this).prop("checked")) {
            $(".destUnitNo").val($(".srcUnitNo").val());
            $(".destAddress1").val($(".srcAddress1").val());
            $(".destAddress2").val($(".srcAddress2").val());
            $(".destSuburb").val($(".srcSuburb").val());
            $(".destState").val($(".srcState").val());
            $(".destPostcode").val($(".srcPostcode").val());
        }
        else {
            $(".destUnitNo").val(null);
            $(".destAddress1").val(null);
            $(".destAddress2").val(null);
            $(".destSuburb").val(null);
            $(".destState").val(null);
            $(".destPostcode").val(null);
        }
    });
}

function InitializeFormRequest(sender, args) {
    ToogleGuardianTable();
}

function EndFormRequest(sender, args) {
    ToogleGuardianTable();
    $("select[name*='AgeBracket']").change(function () {
        ToogleGuardianTable();
    });
    BindControlEvents();
    InitAutoCompl(); //rebind auto complete web part's event
    CopyAddressFields(); //rebind copy address web part's event
}
function BindControlEvents() {
    $("input.PrefServiceChooser").keyup(function (e) {
        // if key not return, tab or arrows clear service id
        if (e.which != 13 && e.which != 9 && e.which != 35 && e.which != 36 && e.which != 37 && e.which != 38 && e.which != 39 && e.which != 40 && e.which != 46) {
            $(this).parents("div.Column").find("input.PreferredService:first").val("");
        }
    });

    $("input.PrefServiceChooser").blur(function () {
        if ($(this).parents("div.Column").find("input.PreferredService:first").val() == "") {
            $(this).val("");
        }
    });
}

function InitAutoCompl() {
    console.log("bound");
    $("input.PrefServiceChooser").autocomplete("/JSONService.svc/GetNearestServices", {
        dataType: 'json',
        contentType: 'application/json',
        max: 5,
        minChars: 4,
        autoFill: false,
        formatItem: formatItem,
        parse: function (data) {
            var parsed = [];
            if (data.d.length > 0) {
                var items = data.d;
                for (var i = 0; i < items.length; i++)
                    parsed[i] = {
                        data: [items[i]],
                        value: items[i],
                        result: [items[i]]
                    };
            }
            return parsed;
        }
    }).result(function (event, data) {
        if (data) {
            var dataParts = data[0].split("|");
            $(this).val(dataParts[1]);
            $(this).parents("div.Column").find("input.PreferredService").val(dataParts[0]);
            prevSearch = dataParts[1];
            var hddSelectedUsername = $(this).next();
            $(hddSelectedUsername).val(dataParts[0]);
        }
    });
}

function formatItem(row) {
    return row[0].split("|")[1];
}